import { CasDisplayField, CasStackRow } from 'src/compass/shared/components';
import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';

type Props = {
  data: any;
};

export default function SceReportsHeaderInfo({ data }: Props) {
  return (
    <>
      <CasStackRow className="bordered-cells">
        <CasDisplayField label="Insured Name" value={data?.insuredName} />
        <CasDisplayField label="State" value={data?.state} />
        <CasDisplayField label="Type" value={data?.type} />
        <CasDisplayField label="CY" value={data?.reinsuranceYear} />
        <CasDisplayField label="Policy#" value={data?.policyNumber} />
        <CasDisplayField label="Sce" value={data?.sce} />
        <CasDisplayField label="Processing Status" value={data?.processingStatus} />
        <CasDisplayField label="Agency" value={data?.insAgency} />
      </CasStackRow>

      <CasStackRow className="bordered-cells">
        <CasDisplayField label="Status" value={data?.status} />
        <CasDisplayField label="Eff Date" value={formatDate(data?.effectiveDate, DateFormat.MDY)} />
        <CasDisplayField label="End Date" value={formatDate(data?.endDate, DateFormat.MDY)} />
        <CasDisplayField label="HC Insured" value={data?.hcInsured} />
        <CasDisplayField label="Target Wt" value={data?.targetCWt} />
        <CasDisplayField label="Grower Email" value={data?.growerEmail} />
        <CasDisplayField label="Relationship Owner" value={data?.relationshipOwner} />
        <CasDisplayField label="Signing Agent" value={data?.signingAgent} />
      </CasStackRow>
    </>
  );
}
